import { Reducer } from 'redux';
import { IApiRequest, IDocumentBlob } from '../../types/index';
import {
  GET_STORE_DOCUMENT_BLOB_REQUEST,
  GET_STORE_DOCUMENT_BLOB_RESPONSE,
  GET_STORE_DOCUMENT_BLOB_ERROR,
} from '../../actions/StoreDocuments/downloadStoreDocumentAdminBlobAction';

const initialState: IApiRequest<IDocumentBlob> = {
  data: undefined,
  error: '',
  UpdatedAt: null,
  loading: false,
};

const downloadStoreDocumentBlobReducer: Reducer<IApiRequest<IDocumentBlob>>
  = (state: IApiRequest<IDocumentBlob> = initialState, action: any) => {
    switch (action.type) {
      case GET_STORE_DOCUMENT_BLOB_REQUEST: {
        return {
          data: action.response,
          error: '',
          UpdatedAt: new Date(),
          loading: true,
        };
      }
      case GET_STORE_DOCUMENT_BLOB_RESPONSE: {
        return {
          data: undefined,
          error: '',
          UpdatedAt: null,
          loading: false,
        };
      }
      case GET_STORE_DOCUMENT_BLOB_ERROR: {
        return {
          data: undefined,
          error: 'An unknown error has occured while downloading the document.',
          UpdatedAt: null,
          loading: false,
        };
      }
      default: {
        return state;
      }
    }
  };

export default downloadStoreDocumentBlobReducer;
